import { msg } from '@lingui/core/macro';

export const SHARED_VESSELS_CUSTOM_RENDER_SELECT_ALL = msg`Select All`;
export const SHARED_VESSELS_CUSTOM_RENDER_CLEAR_ALL = msg`Clear All`;
export const SHARED_VESSELS_CUSTOM_RENDER_CANCEL = msg`Cancel`;
export const SHARED_VESSELS_CUSTOM_RENDER_DONE = msg`Done`;
export const SHARED_VESSELS_CUSTOM_RENDER_NO_RESULTS = msg`No subtypes match your search`;
